import { Component, inject, input } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { I18nModule } from '@spartacus/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MakeAPaymentService } from '../make-a-payment.service';
import { NoItemsDisclaimerComponent } from '../no-items-disclaimer/no-items-disclaimer.component';
import { LoaderComponent } from '../../account-overview/account-overview/loader/loader.component';
import { CommonUtils } from '../../shared/utils/common.utils';
import { EU_DATE_FORMAT, US_DATE_FORMAT } from '../../shared/config/app.config';

@Component({
  selector: 'app-credits-list',
  standalone: true,
  imports: [
    CurrencyPipe,
    I18nModule,
    ReactiveFormsModule,
    NoItemsDisclaimerComponent,
    LoaderComponent
  ],
  templateUrl: './credits-list.component.html'
})
export class CreditsListComponent {
  private readonly makeAPayment = inject(MakeAPaymentService);

  protected readonly CommonUtils = CommonUtils;
  protected readonly US_DATE_FORMAT = US_DATE_FORMAT;
  protected readonly EU_DATE_FORMAT = EU_DATE_FORMAT;

  creditList = input<any[]>([]);
  isLoading = input<boolean>(false);

  invoicePdf(invoiceNo: string): void {
    this.makeAPayment.downloadPdf(invoiceNo);
  }
}
